import styled from '@emotion/styled';
import { createTokenKey, selectToken } from '@caudena/web-platform'
export const GlobalSearchBody = styled.div`
  padding: ${({ theme }) =>
    `0 ${selectToken(theme, createTokenKey(['padding', 'lg']))}`};
`
